import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "../rootReducer";

const userState = (state: AppState) => state.user;
const users = createSelector(userState, (state) => state.users);

export const userSelector = {
  users,
};
